import LoadingState from '../../components/common/LoadingState.jsx';
import PageHero from '../../components/common/PageHero.jsx';
import Seo from '../../components/common/Seo.jsx';
import { useContent } from '../../hooks/useContent.js';
import { assetUrl } from '../../services/storefrontService.js';

export default function GalleryPage() {
  const { content, status } = useContent();
  if (status === 'loading') return <LoadingState label="Loading gallery" />;

  return (
    <>
      <Seo
        title="Gallery"
        description="Scenes from the apiary, the harvest, and the pantry — photos from La Bella Trading's Mediterranean beekeeping partners."
        path="/gallery"
      />
      <PageHero
        eyebrow="Gallery"
        title={content.gallery.title}
        text="Scenes from the apiary, the harvest, and the pantry."
        image={content.gallery.banner || 'assets/uploads/vgallery-banner.jpg'}
      />
      <section className="container page-section">
        <div className="gallery-grid">
          {content.gallery.items.map((item) => (
            <figure key={item.id}>
              <img
                src={assetUrl(item.image)}
                alt={item.caption}
                loading="lazy"
                onError={(event) => { event.currentTarget.closest('figure').style.display = 'none'; }}
              />
              <figcaption>{item.caption}</figcaption>
            </figure>
          ))}
        </div>
      </section>
    </>
  );
}
